<template>
    <div class="g-header-left">
        <div class="nav_head">
            <div v-if="oGly" class="head_li" :class="[navSel == 1 ? 'head_li_s' : '']" @click="openGly">管理员管理</div>
            <div v-if="oYwdl" class="head_li" :class="[navSel == 2 ? 'head_li_s' : '']" @click="openYw">业务代理</div>
            <div v-if="oNrgl" class="head_li" :class="[navSel == 3 ? 'head_li_s' : '']" @click="openNr">内容管理</div>
            <div v-if="oSkyx" class="head_li" :class="[navSel == 4 ? 'head_li_s' : '']" @click="openYx">熟客优选</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        navSel: {
            type: [String, Number],
            default: 1
        }
    },
    data () {
        return {
           oGly: false, 
           oYwdl: false, 
           oNrgl: false, 
           oSkyx: false
        }
    },
    created () {
        this.getRoleInfo()  
    },
    methods: {
        getRoleInfo(){
            // JSON.stringify(res.data.data.role).indexOf('agent') != -1
            // 商家：merchant，代理商：agent，内容管理：content
            // 熟客优选：optimize，帮卖物料：helpsell
            // 业务管理：business，商家发布：publish
            let role = localStorage.getItem("role");
            if(role.indexOf('admin') != -1){
                this.oGly = true
                this.oYwdl = true
                this.oNrgl = true
                this.oSkyx = true
            }else{
                if(role.indexOf('optimize') != -1){
                    this.oSkyx = true
                }else{
                    this.oSkyx = false
                }
                if(role.indexOf('business') != -1){
                    this.oYwdl = true
                }else{
                    this.oYwdl = false
                }
                if(role.indexOf('content') != -1){
                    this.oNrgl = true
                }else{
                    this.oNrgl = false
                }
            }
        },
        openGly(){
            this.$router.push({path: '/glyMg'});
        },
        openYw(){
            this.$router.push({path: '/dlsOne'});
        },
        openNr(){
            this.$router.push({path: '/bmOne'});
        },
        openYx(){
            this.$router.push({path: '/goods'});
        }
    }
}
</script>

<style lang="less">
.g-header-left {
    background-color: #5c6be8;
    color: #fff;
    height: 60px;
    line-height: 60px;
    text-align: center;
    .nav_head{
        display: flex;
        flex-direction: row;
        .head_li{
            width: 140px;
            cursor: pointer;
        }
        .head_li_s{
            background-color: #424eba;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/navHead.vue